module.exports = __webpack_public_path__ + "img/home_producttwo.ddddfa9b.jpg";